"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GDD_WORDINGS = {
    DELETE: {
        DEFAULT: 'Le jour de retrait sélectionné n’est plus disponible.',
        CONTEXT_BASKET: "Le jour de retrait s\u00E9lectionn\u00E9 de votre panier n\u2019est plus disponible. <br><br>{minimumDateBrief}",
        STATUS: 'Ce jour de retrait n\'est plus disponible',
    },
    FULL: {
        DEFAULT: "Vous ne pouvez pas choisir ce jour de retrait car il est actuellement complet. Veuillez s\u00E9lectionner un autre jour et/ou un autre point de retrait.",
        CONTEXT_BASKET: "Vous ne pouvez pas ajouter d'\u00E9l\u00E9ment \u00E0 votre panier car le point de retrait est complet sur le jour s\u00E9lectionn\u00E9.",
        STATUS: 'Ce point de retrait est complet',
    },
    MINIMUM_DATE_BRIEF: 'Pour recevoir votre panier cette semaine avant le {minimumDate}, veuillez <b>modifier votre date de retrait ou votre point de retrait.</b>',
    NOT_AVAILABLE: {
        DEFAULT: 'Vous ne pouvez pas sélectionner ce jour de retrait car il est indisponible.',
        STATUS: 'Ce jour de retrait n\'est pas disponible',
    },
    SUBSTITUTE: {
        DEFAULT: 'Les commandes seront livrées dans un point relais remplaçant ce jour.',
        STATUS: 'Point de retrait remplaçant',
    },
    TOO_LATE: {
        DEFAULT: 'Votre jour de retrait est fixé pour la prochaine sélection de produits. Veuillez choisir un autre jour de retrait ou ajouter de nouveaux articles à votre panier à partir de jeudi.',
        STATUS: 'Vous devrez attendre jeudi pour passer commande ce jour.',
    },
};
exports.default = GDD_WORDINGS;
//# sourceMappingURL=GroupDeliveryDay.js.map